import React from "react"
import { List, ListItem, ListItemText, Link } from "@material-ui/core"
import { toId } from "@utils/data"

const TableOfContents = ({ contentTableOfContents, classes, scrollTo }) => {
  if (!contentTableOfContents || contentTableOfContents.length === 0) {
    return null
  }

  return (
    <List>
      {contentTableOfContents?.map((tocItem) => (
        <ListItem
          key={toId(tocItem)}
          component={Link}
          href={`#${tocItem.id}`}
          onClick={(event) => scrollTo(event, toId(tocItem))}
          classes={{ root: [classes.listItemTocExpansion].join(" ") }}
        >
          <ListItemText>{tocItem.content}</ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

export { TableOfContents }
